<template>
  <div>
    <h1 class="scroll-border-dom">合规咨询类</h1>
    <ul>
      <li>
        <div class="title">预裁定</div>
        <div class="desc">提供预裁定咨询服务并协助企业向海关递交申请与获得裁定。预归类、预审价、原产地预确定</div>
      </li>
      <li>
        <div class="title">贸易合规</div>
        <div class="desc">为企业在特定国家或地区的进出口活动提供法律法规咨询。AEO咨询、FTA咨询、贸易管制咨询、知识产权边境保护</div>
      </li>
      <li>
        <div class="title">海关稽查</div>
        <div class="desc">协助应对海关稽查，准备说明资料，最小化稽查风险。原产地稽查、归类稽查、价格稽查、加工贸易稽查</div>
      </li>
    </ul>
    <h1 class="scroll-border-dom icon2">系统实施类</h1>
    <ul>
      <li>
        <div class="title">关税筹划</div>
        <div class="desc">根据企业的贸易现状与需求进行全面的国际业务梳理与战略筹划。确定实施关税筹划后可产生的节税效益与可行性</div>
      </li>
      <li>
        <div class="title">选择系统</div>
        <div class="desc">根据企业的不同需求来协助企业选择适合的贸易合规管理系统帮助企业了解国际上不同的管理系统的特点与功能，根据企业的性质、所属产业类型、<p style="margin-top: 5px;">贸易方式、经营规模等情况作出最佳选择</p></div>
      </li>
      <li>
        <div class="title">模块设计</div>
        <div class="desc">协助企业确定系统的基本功能模块，如商品进出口信息管理、报关单证管理、加工贸易管理、供应商管理等，帮助企业实现信息化集成管理功能</div>
      </li>
      <li>
        <div class="title">系统维护</div>
        <div class="desc">为企业提供系统运行及数据信息的维护更新服务，为企业的从业人员提供更多的专业化培训，以保障系统的正常管理与运行</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'ExpertServiceContent'
}
</script>
<style scoped>
  h1{
    font-size: 16px;
    color: #1F8AFD;
    margin: 25px 0 0;
    padding-bottom: 20px;
    font-weight: normal;
    background: url("~@/assets/images/icons/help/1.png") 0 4px no-repeat transparent;
    padding-left: 22px;
    background-size: 14px auto;
  }
  h1.icon2{
    margin-top: 35px;
    background-image: url("~@/assets/images/icons/help/2.png");
  }
  ul{
    margin-left: 8px;
  }
  ul li{
    margin-bottom: 25px;
    background: url("~@/assets/images/icons/help/arrow.png") 0 5px no-repeat transparent;
    background-size: 8px auto;
    padding-left: 15px;
  }
  ul li .title{
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 6px;
    color: #333;
  }
  ul li .desc{
    color: #333;
    font-size: 14px;
    line-height: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/exportHelp/Content.vue